import styled from 'styled-components';
import { Typography } from '~/components';
import { getThemeByPath } from '~/utils';

type AnimatedText = {
  isShowing?: boolean;
};

const smallSpacing = getThemeByPath('spacings.small');

const defaultSubtitleWrapperHeight = 400;
const animationDurationMS = 1000;

const handleSbtWrapperAnimationText = ({ isShowing }: AnimatedText) =>
  isShowing
    ? 'opacity-fade-in, padding-left-fade-in'
    : 'opacity-fade-out, padding-left-fade-out';

const handleGSbtWrapperAnimationText = ({ isShowing }: AnimatedText) =>
  isShowing
    ? 'opacity-fade-in, padding-right-fade-in'
    : 'opacity-fade-out, padding-right-fade-out';

export const SubtitleWrapper = styled.div<AnimatedText>`
  height: ${defaultSubtitleWrapperHeight}px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const SbtWrapper = styled.div<AnimatedText>`
  animation-fill-mode: forwards;
  animation-duration: ${animationDurationMS}ms;
  animation-name: ${handleSbtWrapperAnimationText};
`;

export const GSbtWrapper = styled.div<AnimatedText>`
  animation-fill-mode: both;
  animation-duration: ${animationDurationMS}ms;
  animation-name: ${handleGSbtWrapperAnimationText};
  animation-delay: ${animationDurationMS}ms;
`;

export const Subtitle = styled(Typography).attrs({
  variant: 'headline1',
  typographyProps: {
    style: {
      textAlign: 'center',
    },
  },
})``;

export const GreenSubtitle = styled(Typography).attrs({
  variant: 'headline1',
  textColor: 'colors.success.main',
  typographyProps: {
    style: {
      textAlign: 'center',
    },
  },
})``;

export const ButtonIconWrapper = styled.div`
  margin: ${smallSpacing}px;
`;

export const OptionsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export const OptionsWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
`;
